module.exports = __webpack_public_path__ + "img/4decc85ac7f1738776b5705a8c7e054f.png";